"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

import { User } from "@/lib/api/types";

interface UserSelectionContextType {
    selectedUser: User | undefined;
    setSelectedUser: (user: User | undefined) => void;
}

const UserSelectionContext = createContext<UserSelectionContextType | undefined>(
    undefined
);

export function UserSelectionProvider({ children }: { children: ReactNode }) {
    const [selectedUser, setSelectedUser] = useState<User | undefined>(
        undefined
    );

    return (
        <UserSelectionContext.Provider
            value={{ selectedUser, setSelectedUser }}
        >
            {children}
        </UserSelectionContext.Provider>
    );
}

export function useUserSelection() {
    const context = useContext(UserSelectionContext);
    if (context === undefined) {
        throw new Error(
            "useUserSelection must be used within a UserSelectionProvider"
        );
    }
    return context;
}
